import fullscreen from './fullscreen';
import titleBar from './titleBar';
import l3One from './l3One';
import l3Two from './l3Two';
import sideSlab from './sideSlab';
import fullscreenImage from './fullscreenImage';
import ticker from './ticker';

export default {
  fullscreen,
  titleBar,
  l3One,
  l3Two,
  sideSlab,
  fullscreenImage,
  ticker,
};
